import { awaitRequests, promise } from '../../../helpers';
import { saveCourseAssignationFiles } from './index';

const addCourseAssignation = ({ data, uploadList }) => {
    return (dispatch, getState, getFirebase) => {
        // -- add
        const add = d => {
            return getFirebase()
                .firestore()
                .collection('coursesAssignations')
                .add(d)
                .then(docRef => promise({ ...d, id: docRef.id }));
        };

        // after add
        const afterAdd = item => {
            const reqs = [];

            // save files
            reqs.push(dispatch(saveCourseAssignationFiles({ item, uploadList })));

            return awaitRequests(reqs).then(() => promise(item));
        };

        // --
        if (data) {
            return add(data).then(item => afterAdd(item));
        }

        return promise();
    };
};

export default addCourseAssignation;
